module.exports = __webpack_public_path__ + "static/img/clothing_02.e570e20.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/inventory/stickers/clothing_02.png
// module id = z61j
// module chunks = 0